export const sentryUnmask = (className: $TSFixMe) =>
  `${className} sentry-unmask`;
